import { fetcher } from "@certn/api";

type ResponseType = {
  presigned_url: string;
};

export const tryOpenDocumentInNewTab = async (
  downloadUrl: string | undefined,
  fileKey: string | undefined
) => {
  if (!fileKey || !downloadUrl || !fileKey.includes("/")) {
    console.error("Cannot construct download URL");
    return;
  }

  const fileName = fileKey.split("/")[1];
  try {
    const response = await fetcher.request<ResponseType>(
      `${downloadUrl}${fileName}`
    );
    open(response.presigned_url, "_blank");
  } catch (error) {
    console.error("Error downloading file", error);
  }
};
